// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

export default class General {
	constructor() {
		this.menuOpenClassName = "is-main-menu-open";
		this.vh = window.innerHeight * 0.01;
		this.allVH = document.querySelectorAll(".vh");
		this.isSafari = false;
		this.init();
		this.events();
	}

	init() {
		if (this.allVH) {
			Array.prototype.slice.call(this.allVH).forEach((el) => {
				el.style.setProperty("--vh", `${this.vh}px`);
			});
		}

		this.checkForSafari.bind(this)();
	}

	checkForSafari() {
		this.isSafari = window.safari !== undefined;
		if (this.isSafari) {
			document.body.classList.add("is-safari");
		}
	}

	getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(";").shift();
	}

	events() {
		window.addEventListener("resize", () => {
			if (this.allVH) {
				this.vh = window.innerHeight * 0.01;
				Array.prototype.slice.call(this.allVH).forEach((el) => {
					el.style.setProperty("--vh", `${this.vh}px`);
				});
			}
		});

		if (document.getElementById("contact-submit")) {
			document.getElementById("contact-submit").addEventListener(
				"click",
				(ev) => {
					document.getElementById("ga-user-id").value = this.getCookie("_ga");
					return true;
				},
				false
			);
		}
	}
}
